import Provider from './Provider';

class WistiaPlayer extends Provider {
    constructor(videoId, playerBox) {
        super();
        this.videoId = videoId;
        this.playerBox = playerBox;
        this.player = false;
    }

    playerScriptSrc() {
        return 'https://fast.wistia.com/assets/external/E-v1.js';
    }

    playerScriptId() {
        return 'wistia-player-iframe-api';
    }

    #createPlayer() {
        if (this.playerExist()) {
            return;
        }

        this.playerBox.setAttribute('id', `wistia_${this.videoId}`);

        this.player = window.Wistia.embed(this.videoId, {
            videoFoam: true,
            autoPlay: true,
        });
    }

    createPlayerBox() {
        if (document.getElementById(this.playerScriptId())) {
            this.#createPlayer();
            return;
        }

        this.loadVideoScripts(() => this.#createPlayer());
    }

    play() {
        if (this.playerExist()) {
            this.player.play();
        }
    }

    pause() {
        if (this.playerExist()) {
            this.player.pause();
        }
    }
}

export default WistiaPlayer;